import { trackEvent } from "@/lib/audit";

export interface HalftimeMemoryEntry {
  match_id: string;
  home_label: string;
  away_label: string;
  home_score: number;
  away_score: number;
  top_moments: string[]; // short emotional descriptions
  user_actions: { predictions: number; votes: number; shares: number };
  saved_at: string;
}

const KEY = "ss2026_halftime_memory_v1";
const MAX = 5;

export function recordHalftimeMemory(entry: HalftimeMemoryEntry) {
  if (typeof window === "undefined") return;
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? (JSON.parse(raw) as HalftimeMemoryEntry[]) : [];
    const filtered = arr.filter((e) => e.match_id !== entry.match_id);
    filtered.unshift(entry);
    localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, MAX)));
  } catch { /* noop */ }
}

export function listHalftimeMemories(): HalftimeMemoryEntry[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as HalftimeMemoryEntry[]) : [];
  } catch { return []; }
}

export function getLatestHalftimeMemory(): HalftimeMemoryEntry | null {
  return listHalftimeMemories()[0] ?? null;
}

export function replayHalftimeMemory(matchId: string) {
  void trackEvent("halftime_memory_replayed", { match_id: matchId });
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("ss2026:open-halftime", { detail: { match_id: matchId } }));
  }
}